import type { AnchorProps } from "@mantine/core"
import type { PropsWithChildren } from "react"
import type { TSession, TSessionBase, TUserSession } from "@/types"
import { buildSessionURL, buildUserSessionURL } from "@/utils"
import { AppLink, type TAppLinkProps } from "../utils"

export function SessionLink({
  session,
  children,
  ...props
}: AnchorProps & PropsWithChildren<{ session: TSession | TSessionBase }>) {
  const url = buildSessionURL(session, session.state == "finished" ? "summary" : undefined)
  return (
    <AppLink href={url} {...props}>
      {/* @ts-ignore */}
      {children || session.title}
    </AppLink>
  )
}

export function UserSessionLink({
  children,
  usersession,
  ...props
}: PropsWithChildren<{ usersession: TUserSession }> & Omit<TAppLinkProps, "href">) {
  return (
    <AppLink href={buildUserSessionURL(usersession)} {...props}>
      {children || usersession.session.title}
    </AppLink>
  )
}
